import { NavigateFn } from '@tanstack/react-router'
import { Column, ColumnDef, ColumnFiltersState } from '@tanstack/react-table'
import { ActiveFilters } from 'components/table/enhancements/filters/ActiveFilters'
import { FilterHeaderButton } from 'components/table/utility/FilterHeaderButton'
import styled from 'styled-components'

const FilterBarContainer = styled.div`
  display: flex;
  gap: 1rem; /* Increased spacing between filters */
  min-width: 0;
  align-items: center;

  /* Remove gray background from filter buttons */
  ${FilterHeaderButton} {
    background-color: transparent !important;
    min-width: 6rem;
  }
`

// Permanent filters for the ship filter bar
const DEFAULT_SHIP_FILTERS = ['class', 'fleet', 'homeport']

/**
 * ShipFilterBar - A permanent filter bar for navy ship tables
 * Displays three permanent multi-select filters (class, fleet, homeport) that cannot be removed.
 * Each filter includes an "All" option as the default state.
 */
export const ShipFilterBar = <TData,>({
  columns,
  getColumn,
  columnFilters,
  initialColumnFilters,
  navigate,
  disableUrlFilters,
}: {
  columns: ColumnDef<TData>[]
  getColumn: (columnID: string) => Column<TData, unknown> | undefined
  columnFilters?: string[]
  initialColumnFilters?: ColumnFiltersState
  navigate: NavigateFn
  disableUrlFilters?: boolean
}) => {
  // filters are managed in the filter components
  return (
    <FilterBarContainer>
      <ActiveFilters
        columns={columns}
        activeFilters={columnFilters || DEFAULT_SHIP_FILTERS}
        setActiveFilters={() => {}} // No-op: filters are permanent
        getColumn={getColumn}
        initialColumnFilters={initialColumnFilters}
        navigate={navigate}
        disableUrlFilters={disableUrlFilters}
        inputVisible={false}
        showAllOption={true}
      />
    </FilterBarContainer>
  )
}
